import React, { Component, useRef, useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { withRouter } from 'react-router-dom';
import styles from './Profile.scss';
import Footer from 'components/Footer';
import ProfileForm from './ProfileForm';
import SubscriptionBar from 'components/Payments/SubscriptionBar';
import { USER_ROLE } from 'constants';
import { getUserRole } from 'utils';
import withObservePayments from 'decorators/withObservePayments';
import tracker from '../../services/tracker';
import { withTranslation } from 'react-i18next';
import { gaEvent, trackGA } from 'services/ga';
import { ButtonSpinner } from '../common/ButtonSpinner/ButtonSpinner';
import { loadAppointmentStatuses } from '../../actions/appointment';
import Appointments from './Appointments/Appointments';

const ProfileEvents = React.memo(({ profile }) => {
  const isSent = useRef(false);
  const { firstName, lastName, phone, tariff } = profile;

  useEffect(() => {
    if (!firstName || !lastName || !phone) {
      return;
    }

    if (isSent.current) {
      return;
    }

    isSent.current = true;

    const { countDay, datePay } = tariff;

    tracker.sendEvent('SUBSCRIPTION', {
      телефон: phone
        ? `${phone[0]} (${phone.slice(1, 4)}) ${phone.slice(4, 7)} ${phone.slice(
            7,
            9
          )} ${phone.slice(9)}`
        : '',
      имя_пользователя: `${firstName} ${lastName}`,
      дата_подписки: datePay ? datePay.slice(0, 10).split('-').reverse().join('/') : '',
      оставшиеся_дни: countDay,
    });
  }, [firstName, lastName, phone]);

  return null;
});

@withObservePayments
class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: this.getActiveTabFromQuery(),
    };
  }

  componentDidMount() {
    trackGA(
      gaEvent.pageShow({
        screenName: this.props.location.pathname,
      })
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this.setState({ activeTab: this.getActiveTabFromQuery() });
    }
  }

  getActiveTabFromQuery = () => {
    const params = new URLSearchParams(this.props.location.search);
    return params.get('tab') || 'profile';
  };

  handleSwitchContent = async (tab) => {
    const { history, profile } = this.props;
    const eventLabel = tab === 'profile' ? 'moi_dannye' : 'moi_zapisi';

    trackGA(
      gaEvent.profileTabsClick({
        eventLabel,
        user_id: profile.id,
      })
    );

    if (tab === this.state.activeTab) {
      return;
    }

    history.push(`/profile?tab=${tab}`);
  };

  render() {
    const { roleName, agencyId, profile, t } = this.props;
    const { activeTab, isAppointmentsLoading } = this.state;
    const role = getUserRole(profile);
    const hasNoPermission = roleName && agencyId && roleName !== 'admin' && roleName !== 'owner';

    return (
      <div className={styles.ProfileWrap}>
        <div className={cn(styles.Profile, { [styles.HasNotification]: hasNoPermission })}>
          {hasNoPermission && (
            <div className={styles.PermissionNotification}>
              {t('components.profile.profile.noPermission')}
            </div>
          )}
          <div className={styles.Container}>
            <div className={styles.Title}>{t('components.profile.profile.title')}</div>
            <div className={styles.ButtonGroup}>
              <button
                className={cn(styles.TabButton, { [styles.Active]: activeTab === 'profile' })}
                onClick={() => this.handleSwitchContent('profile')}
              >
                {t('components.profile.profile.profileTab')}
              </button>
              <button
                className={cn(styles.TabButton, { [styles.Active]: activeTab === 'appointments' })}
                onClick={() => this.handleSwitchContent('appointments')}
              >
                {t('components.profile.profile.appointmentsTab')}
                {isAppointmentsLoading && <ButtonSpinner />}
              </button>
            </div>
            {activeTab === 'profile' ? (
              <Fragment>
                {role === USER_ROLE.INDIVIDUAL && (
                  <SubscriptionBar className={styles.SubscriptionBarInProfile} />
                )}
                <ProfileForm />
              </Fragment>
            ) : (
              <Appointments profile={profile} />
            )}
          </div>
        </div>
        <ProfileEvents profile={profile} />
        <Footer />
      </div>
    );
  }
}

export default connect(
  ({ profile }) => ({
    roleName: profile && profile.roleName,
    agencyId: profile && profile.agencyId,
    profile,
  }),
  (dispatch) => ({
    dispatch,
    loadAppointmentStatuses,
  })
)(withRouter(withTranslation()(Profile)));



// WEBPACK FOOTER //
// ./src/components/Profile/Profile.js